import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants";
import { UpdateInfoBarDataRequestBody } from "./updateInfoBarData.types";

export const requestUpdateInfoBarData = async (
  body: UpdateInfoBarDataRequestBody
): Promise<void> => {
  return await instance.post(ApiRoutesContent.InfoBar, body);
};
